import { Dispatch } from "redux";
import { ACTION_TYPES } from "../constants/actionTypes";
import { SUPER_ADMIN_TYPES } from "../constants/superAdminTypes";
import { getSuperAdminAnalytics, getUsageAnalytics, getRetentionAnalytics } from "@api/user/superAdmin";

// Assuming the setLoading function takes a boolean and returns void
type SetLoadingType = (isLoading: boolean) => void;

/********************************************
 * Get super admin analytics action
 * ******************************************/
export const getSuperAdminAnalyticsAction =
  (setLoading: SetLoadingType, timeRange?: string) => async (dispatch: Dispatch) => {
    // Dispatch a loading alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      // Fetch response from server
      const res = await getSuperAdminAnalytics(timeRange);

      // Dispatch archives
      dispatch({
        type: SUPER_ADMIN_TYPES.GET_SUPER_ADMIN_ANALYTICS,
        payload: res.data,
      });

      // Dispatch a success/error sign up alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: { loading: false },
      });

      // Set loading to false
      setLoading(false);
    } catch (error) {
      // Dispatch a error alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: "GET_SUPER_ADMIN_ANALYTICS_ACTION_ERROR",
        },
      });
      setLoading(false);
    }
  };

/********************************************
 * Get usage analytics action
 * ******************************************/
export const getUsageAnalyticsAction =
  (setLoading: SetLoadingType, timeRange?: string) => async (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      const res = await getUsageAnalytics(timeRange);

      dispatch({
        type: SUPER_ADMIN_TYPES.GET_USAGE_ANALYTICS,
        payload: res.data,
      });

      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: { loading: false },
      });

      setLoading(false);
    } catch (error) {
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: "GET_USAGE_ANALYTICS_ACTION_ERROR",
        },
      });
      setLoading(false);
    }
  };

/********************************************
 * Get retention analytics action
 * ******************************************/
export const getRetentionAnalyticsAction =
  (setLoading: SetLoadingType, timeRange?: string) => async (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      const res = await getRetentionAnalytics(timeRange);

      dispatch({
        type: SUPER_ADMIN_TYPES.GET_RETENTION_ANALYTICS,
        payload: res.data,
      });

      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: { loading: false },
      });

      setLoading(false);
    } catch (error) {
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: "GET_RETENTION_ANALYTICS_ACTION_ERROR",
        },
      });
      setLoading(false);
    }
  };
